interface Props {
  [key: string]: any
}

export default function WelcomeIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M3.08569 17.5087C3.17147 17.119 3.13873 16.7126 2.99169 16.3417C1.96846 14.2186 1.72795 11.8024 2.31258 9.51933C2.89722 7.23624 4.26944 5.23299 6.18713 3.86303C8.10483 2.49308 10.4448 1.84445 12.7941 2.03159C15.1434 2.21873 17.3511 3.22962 19.0278 4.88589C20.7044 6.54216 21.7422 8.73738 21.958 11.0842C22.1738 13.4311 21.5538 15.7788 20.2074 17.7131C18.861 19.6473 16.8746 21.0439 14.5988 21.6564C12.3231 22.2689 9.90408 22.0579 7.76869 21.0607C7.41822 20.9276 7.03741 20.8958 6.66969 20.9687L3.25669 21.9667C3.09205 22.0104 2.91898 22.0113 2.75389 21.9693C2.5888 21.9274 2.43716 21.844 2.31336 21.727C2.18955 21.61 2.09769 21.4633 2.04647 21.3008C1.99525 21.1384 1.98638 20.9655 2.02069 20.7987L3.08569 17.5087Z"
        fill="white"
        stroke="#8E47DB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M7.8276 13.0696C7.29153 12.5089 6.99352 11.7623 6.99611 10.9865C6.99871 10.2108 7.30171 9.46617 7.84151 8.90902C8.38132 8.35188 9.11597 8.0255 9.89125 7.99839C10.6665 7.97128 11.4222 8.24554 11.9996 8.76362C12.4304 8.37694 12.9638 8.12314 13.5356 8.03283C14.1074 7.94252 14.693 8.01956 15.222 8.25466C15.751 8.48976 16.2007 8.87288 16.5168 9.3578C16.8329 9.84273 17.002 10.4088 17.0036 10.9876C17.006 11.7634 16.7078 12.51 16.1716 13.0706L12.7246 16.6906C12.6311 16.7889 12.5186 16.8671 12.3939 16.9205C12.2693 16.974 12.135 17.0015 11.9994 17.0014C11.8637 17.0013 11.7295 16.9736 11.6049 16.92C11.4803 16.8664 11.3679 16.788 11.2746 16.6896L7.8276 13.0696Z"
        stroke="#8E47DB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}
